// ReportCard.jsx
import React from "react";

const AiReportCard = ({ title, description, icon, department }) => {
  return (
    <div className="bg-white rounded-xl p-5 shadow-sm border border-gray-100 hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-start">
        <div className="text-2xl mr-4 flex-shrink-0">{icon}</div>
        <div>
          <h3 className="font-semibold text-base text-gray-800">{title}</h3>
          <p className="text-gray-600 text-sm mt-1">{description}</p>
          {department && (
            <span className="inline-block mt-2 px-2 py-1 text-xs font-medium text-blue-600 bg-blue-50 rounded-full">
              {department.charAt(0).toUpperCase() + department.slice(1)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiReportCard;